import gql from 'graphql-tag';
import { MEMBER_FIELD_SCHEMA_FRAGMENT } from './fragments';

export const GET_DEFAULT_MEMBER_FIELD_SCHEMAS_QUERY = gql`
  query GetDefaultMemberFieldSchemasQuery {
    publicDefaultMemberFieldSchemas {
      ...MemberFieldSchemaFragment
    }
  }
  ${MEMBER_FIELD_SCHEMA_FRAGMENT}
`;
